import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';
import { ALERT_QUERY_KEYS } from 'app/modules/alerts/queries/keys';
import { post } from 'app/shared/utils/fetchr';
import { InvestigationActionPayload } from 'app/modules/investigations/types/requests';
import { selectDLEnabledForAlertDetails } from 'app/shared/featureFlags/selectors';

export const useReassignAlert = (ids: number[]) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const useNewEndpoint = useSelector(selectDLEnabledForAlertDetails);
  return useMutation({
    mutationFn: (agentID: number) =>
      post(
        useNewEndpoint
          ? '/v1/investigations/cached/action'
          : '/v1/investigations/action',
        {
          object_ids: ids,
          object_type: 'ALERT',
          agent_id: agentID,
        } satisfies InvestigationActionPayload,
      ),
    onError: () =>
      dispatch(sendErrorToast('Failed to reassign alert. Please try again.')),
    onSuccess: () => {
      dispatch(sendSuccessToast('Successfully reassigned alert.'));
      ids.forEach((i) => {
        queryClient.invalidateQueries({
          queryKey: ALERT_QUERY_KEYS.getAlert(i, true),
        });
        queryClient.invalidateQueries({
          queryKey: ALERT_QUERY_KEYS.getAlert(i, false),
        });
      });
    },
  });
};
